import { apiGet, apiPost } from './default'

function getEvents(categoryValue) {
    //let query = '/calendar/index.php?categoryValue=' + categoryValue;
    //return apiGet(API_RESPONSE + query);
    //let query = '/web.rest.service/eventsCalendar/getEventList?category=' + categoryValue; //For Dev
    let query = '/webrest/eventsCalendar/getEventList?category=' + categoryValue; //For Qa
    return apiGet(REST_API_RESPONSE_QA + query);
}

export default {
    getEvents
}
